// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Mz14","productName":"Table_productName__3DJN2"};